import { pointer } from '../../utils/jss-utils'
import { devices, layouts, font } from '../../config/theme'

const style = {}

style.base = {
  '& h4': {
    fontSize: '16px !important',
    lineHeight: '24px'
  }
}

style.base[devices.desktop] = {
  flexDirection: 'row'
}

style.agreementContainer = {
  // lineHeight: '27px'
}

style.agreementContainer[devices.desktop] = {
  maxWidth: '620px'
  // width: '700px',

  // paddingTop: '47px' //this is to align with sidebar title, faking for now
}
style.titleContainer = {}

style.titleContainer[devices.desktop] = {
  minWidth: layouts.sidebar.width
}

style.acceptContainer = {}

style.acceptContainer[devices.desktop] = {
  marginTop: '40px'
}
style.acceptContainer[devices.mobile] = {
  marginTop: '30px',
  marginBottom: '125px'
}

style.base[devices.mobile] = {
  flexDirection: 'column',
  '& h2': {
    // marginTop: '25px !important'
  }
}

style.termsLabel = {
  marginRight: '50px',
  marginBottom: '65px',
  fontSize: '16px !important',
  fontWeight: '400 !important',
  '& label': {
    fontSize: '100%'
  },

  ...pointer,
  '& input': {
    marginRight: '10px'
  }
}

export default style
